import { Button, styled, Typography } from "@mui/material";
import React, { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTrail, animated as a } from "react-spring";

const SRoot = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Star = () => {
  return <img src="/static/mood/logo.svg" alt="Mood star logo" />;
};

const Title: React.FC<any> = ({ mainUser }) => {
  const { t } = useTranslation("common");
  return (
    <Typography mb={mainUser ? 2 : 0} variant="h4" textAlign="center">
      {mainUser ? t("mood.header") : "Mood"}
    </Typography>
  );
};

const Text = () => {
  const { t } = useTranslation("common");
  return <Typography sx={{ maxWidth: "40ch" }}>{t("mood.text")}</Typography>;
};

const SButton = styled(Button)`
  border-radius: 30px;
  height: 48px;
  width: 195px;
  margin-top: 20px;
  font-size: 14px;
`;

const CustomButton: React.FC<any> = ({ onClick }) => {
  const { t } = useTranslation("common");
  return (
    <SButton variant="contained" onClick={onClick}>
      {t("mood.discover")}
    </SButton>
  );
};

const RedoButton: React.FC<any> = (props) => {
  const { t } = useTranslation("common");
  return (
    <SButton variant="contained" {...props}>
      {t("tests.page.retry")}
    </SButton>
  );
};

const config = { mass: 5, tension: 2000, friction: 200 };

const MoodResultsActionBlock: React.FC<any> = ({
  redo,
  onboarding,
  nextStep,
  mainUser,
}) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const [toggle, set] = useState(false);

  const menu = useSelector((state: any) => state.menu);

  const goToWorks = () => {
    navigate("/app/work");
  };

  const intro = [<Star />, <Title mainUser={mainUser} />, <Text />];

  if (!onboarding) {
    if (menu?.works) {
      intro.push(<CustomButton onClick={goToWorks} />);
    }

    intro.push(<RedoButton onClick={redo} />);
  } else {
    intro.push(
      <SButton variant="contained" onClick={nextStep}>
        {t("btn.continue")}
      </SButton>
    );
  }

  if (!mainUser) {
    intro.splice(2, intro.length - 1);
  }

  useLayoutEffect(() => {
    set(true);
  }, []);

  const trail = useTrail(intro.length, {
    config,
    opacity: toggle ? 1 : 0,
    x: toggle ? 0 : 20,
    height: toggle ? 80 : 0,
    from: { opacity: 0, x: 20, height: 0 },
  });

  return (
    <SRoot>
      {trail.map(({ x, height, ...rest }, index) => (
        <a.div
          key={index}
          className="trails-text"
          style={{
            ...rest,
            transform: x.to((x) => `translate3d(0,${x}px,0)`),
          }}
        >
          {intro[index]}
        </a.div>
      ))}
    </SRoot>
  );
};

export default MoodResultsActionBlock;
